const isFromFieldsDefined = (fromFields) => {
    if (fromFields instanceof Array) {
        return fromFields.length > 0;
    }
    return !!fromFields;
};

export default isFromFieldsDefined;
